// utils/pixelHash.ts — SHA-256 browser utk pixel (split dari pixelPii.ts)
const HEX64 = /^[0-9a-f]{64}$/i;

export function isHashedHex64(v: string): boolean {
    return HEX64.test(String(v || '').trim());
}

// SHA-256 hex via Web Crypto (async) — untuk browser. Fallback sync tidak ada di browser.
export async function sha256HexBrowser(raw: string): Promise<string | undefined> {
    try {
        const s = String(raw || '').trim().toLowerCase();
        if (!s) return undefined;
        if (isHashedHex64(s)) return s.toLowerCase();
        const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(s));
        return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
    } catch { return undefined; }
}
